import { optionsMultipartForm, postRequest } from "../../utils/actions"
import { gaEventWrapper } from "../../utils/utils"
import { clearMsgStatusAction, fieldUpdateStatusAction } from "./slices"

export const sendMsgAction = (payload) => (dispatch) => {
    let sendMsgTimeout
    dispatch(fieldUpdateStatusAction(payload))
    clearTimeout(sendMsgTimeout)
    sendMsgTimeout = setTimeout(() => {
      dispatch(clearMsgStatusAction())
    }, 5000)
  }

  export const postFeedback = (url, payload, gaEventName) => {
    return async (dispatch) => {
      try {
        const result = await postRequest(url, payload, optionsMultipartForm)
        dispatch({ type: 'FEEDBACK_SUCCESS' })
        dispatch(sendMsgAction({ msgBody: 'Your feedback has been submitted. Thank you.' })),
        gaEventWrapper(gaEventName, 'Feedback_Action', 'Feedback - message:Smartsheet submitted')
      } catch (error) {
        console.log(error)
        dispatch(sendMsgAction({ msgBody: 'Feedback form error. Please try again later.' })),
        gaEventWrapper(gaEventName, 'Feedback_Action', 'Feedback - message:Smartsheet cancelled. Please try again later.')
      }
    }
  }